import React, { useState } from 'react';
import './CustomTabs.css';

const CustomTabs = ({ children, defaultActiveKey, className = '' }) => {
  const [activeTab, setActiveTab] = useState(defaultActiveKey);

  // Extract tab data from children
  const tabs = React.Children.map(children, (child) => {
    if (child && child.props.eventKey) {
      return {
        eventKey: child.props.eventKey,
        title: child.props.title,
        disabled: child.props.disabled || false
      };
    }
    return null;
  }).filter(Boolean);

  const handleTabClick = (eventKey) => {
    setActiveTab(eventKey);
  };

  return (
    <div className={`custom-tabs-container ${className}`}>
      {/* Tab Headers */}
      <div className="custom-tabs-header">
        {tabs.map((tab) => (
          <button
            key={tab.eventKey}
            className={`custom-tab-button ${activeTab === tab.eventKey ? 'active' : ''} ${tab.disabled ? 'disabled' : ''}`}
            onClick={() => !tab.disabled && handleTabClick(tab.eventKey)}
            disabled={tab.disabled}
          >
            {tab.title}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      <div className="custom-tabs-content">
        {React.Children.map(children, (child) => {
          if (child && child.props.eventKey === activeTab) {
            return (
              <div className="custom-tab-panel">
                {child.props.children}
              </div>
            );
          }
          return null;
        })}
      </div>
    </div>
  );
};

// Custom Tab Panel Component
export const CustomTabPanel = ({ eventKey, title, disabled, children }) => {
  return null; // This component is only used for data extraction
};

export default CustomTabs;
